import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

export const getFeature = (
    product:
        | Product<ProductFieldSet.ProductTile>
        | Product<ProductFieldSet.Full>,
    featureCodeSuffix: string
) => {
    return product.features.find((feature) => {
        return feature.code.endsWith(featureCodeSuffix);
    });
};

export const getFeatureValue = (
    product:
        | Product<ProductFieldSet.ProductTile>
        | Product<ProductFieldSet.Full>,
    featureCodeSuffix: string
) => {
    return getFeature(product, featureCodeSuffix)?.featureValues.find(
        (featureValue) => {
            return featureValue.valid;
        }
    );
};

export const isAdditionalService = (
    product: Product<ProductFieldSet.Full | ProductFieldSet.ProductTile>
) => {
    if ("montageParents" in product) {
        return product.montageParents.length > 0;
    } else {
        return product.isAdditionalService;
    }
};
